import { render, staticRenderFns } from "./AddGateways.vue?vue&type=template&id=192287fd&scoped=true"
import script from "./AddGateways.vue?vue&type=script&lang=js"
export * from "./AddGateways.vue?vue&type=script&lang=js"
import style0 from "./AddGateways.vue?vue&type=style&index=0&id=192287fd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "192287fd",
  null
  
)

export default component.exports